import { fabric } from 'fabric';

const GUIDE_INSET = 6;
const GUIDE_WIDTH = 3;

// A guide that shows a constant distance between objects.
class GuideSpace extends fabric.Line {
  type = 'guideSpace';
  axis: 'h' | 'y';
  lines: {
    from: number;
    to: number;
  }[];

  _render(ctx: CanvasRenderingContext2D) {
    if (this.canvas.exporting) return;

    const zoom = this.canvas.getZoom();

    ctx.beginPath();
    for (const line of this.lines) {
      const inset = GUIDE_INSET / zoom;

      if (this.axis === 'h') {
        const startPos = line.from + inset - (this.top + this.height / 2);
        const endPos = line.to - inset - (this.top + this.height / 2);
        const guideWidth = Math.min(
          GUIDE_WIDTH / zoom,
          Math.abs(endPos - startPos) / 2
        );
        ctx.moveTo(-guideWidth, startPos);
        ctx.lineTo(guideWidth, startPos);
        ctx.moveTo(0, startPos);
        ctx.lineTo(0, endPos);
        ctx.moveTo(-guideWidth, endPos);
        ctx.lineTo(guideWidth, endPos);
      } else {
        const startPos = line.from + inset - (this.left + this.width / 2);
        const endPos = line.to - inset - (this.left + this.width / 2);
        const guideWidth = Math.min(
          GUIDE_WIDTH / zoom,
          Math.abs(endPos - startPos) / 2
        );
        ctx.moveTo(startPos, -guideWidth);
        ctx.lineTo(startPos, guideWidth);
        ctx.moveTo(startPos, 0);
        ctx.lineTo(endPos, 0);
        ctx.moveTo(endPos, -guideWidth);
        ctx.lineTo(endPos, guideWidth);
      }
    }

    ctx.strokeStyle = this.stroke!;
    ctx.lineWidth = 2 / zoom;
    ctx.stroke();
  }
}

export default GuideSpace;
